import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  showCloseButton = true,
  className = '',
  overlayClassName = '',
  headerContent,
  headerClassName = 'items-start',
  contentClassName = '',
}) => {
  const { t } = useTranslation();

  // Handle escape key
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  // Handle backdrop click
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${overlayClassName}`}
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      onClick={handleBackdropClick}
    >
      <div
        className={`bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden ${className}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Modal Header */}
        {(title || headerContent) && (
          <div className={`flex justify-between p-6 border-b border-gray-200 ${headerClassName}`}>
            {headerContent ? (
              <div className="flex-1">{headerContent}</div>
            ) : (
              <h2 className="text-2xl font-bold" style={{ color: colors.mineShaft }}>
                {title}
              </h2>
            )}
            {showCloseButton && (
              <button
                onClick={onClose}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200 ml-4 flex-shrink-0"
                aria-label={t('GENERAL.close')}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        )}

        {/* Modal Content */}
        <div className={`overflow-y-auto max-h-[calc(90vh-120px)] ${contentClassName}`}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
